import {Message} from "element-ui";
import _request from "../common/_request";
import cache_activity from "../cache/cache_activity";


let lib_activity = {
    // 项目信息， ui
    info: function (activity_id, tids, callback) {
        let data = {};
        data.activity_id = activity_id;
        data.tids = tids;
        _request._get('/activity/info', data, function (response) {
            if (response.code !== _request.success) {
                Message.info(response.msg);
                return;
            }
            // cache_activity.set(response.data);
            callback(response.data)
        })
    },
    // 分享
    share: function (callback) {
        let data = {};
        data.url = encodeURIComponent(window.location.href);
        _request._get('/activity/share', data, function (response) {
            if (response.code !== _request.success) {
                return;
            }
            callback(response.data)
        })
    },

    // 监测
    monitor: function (activity_id, channel, callback) {
        let data = {};
        data.activity_id = activity_id;
        data.channel = channel;
        _request._get('/activity/monitor', data, function (response) {
            //回调数据
            if (typeof callback === 'function')
                callback(response.data)
        });
    },

    //城市
    city: function (city, callback) {
        let data = {};
        data.city = city;
        _request._get('/activity/city', data, function (response) {
            if (response.code !== _request.success) {
                Message.info(response.msg);
                return;
            }
            //回调数据
            if (typeof callback === 'function') {
                callback(response.data)
            }
        })
    },
    //城市
    cityx: function (city, callback) {
        let data = {};
        data.city = city;
        _request._get('/activity/cityx', data, function (response) {
            if (response.code !== _request.success) {
                Message.info(response.msg);
                return;
            }
            //回调数据
            if (typeof callback === 'function') {
                callback(response.data)
            }
        })
    },



};
export default lib_activity
